<template>
  <div id="page-content" tabindex="-1">
    <span
      aria-label="Select Date Time Page"
      aria-live="polite"
      role="contentinfo"
    ></span>
    <h2
      class="public-h5 font-weight-bold mt-5 mb-5"
      :class="isRTLLanguage ? 'rtl' : 'normal'"
    >
      {{ siteText.ui.selectDateTimePageHeader }}
    </h2>
    <p
      class="text-h8 font-weight-bold"
      :class="isRTLLanguage ? 'rtl' : 'normal'"
    >
      {{ siteText.ui.selectDateTimePageSubHeader }}
    </p>
    <v-card>
      <v-card-text class="centerContainer">
        <p :class="isRTLLanguage ? 'rtl' : 'normal'">
          <strong> {{ siteText.ui.selectDateTimeSelectADate }} </strong>
        </p>
        <div :style="isRTLLanguage ? 'text-align:right' : ''">
          <div>
            <v-layout>
              <opus-calendar-date-picker
                :minDate="minDate"
                :maxDate="maxDate"
                :availableDates="availableDates"
                class="pb-4 mb-4"
                @dateChanged="onDateChanged"
                @monthChanged="onMonthChanged"
                :locale="language"
              >
              </opus-calendar-date-picker>
            </v-layout>
          </div>
          <div>
            <input type="hidden" id="contentUpdate" :value="minDate" />
          </div>
        </div>
        <opus-select-only-drop-down
          class="mb-4 vue-select-up"
          :items="availableTimes"
          select-name="timeSelect"
          item-label="FormattedTime"
          item-id="SlotId"
          :place-holder="siteText.ui.selectDateTimeSelectATime"
          :label="siteText.ui.selectDateTimeTime"
          @item:selected="onTimeChange"
          v-model="time"
          :list-top="true"
          :disabled="!this.selectedDate"
        >
        </opus-select-only-drop-down>
        <p style="line-height: 24px" :class="isRTLLanguage ? 'rtl' : 'normal'">
          <strong> {{ siteText.ui.selectedService }}: </strong>
          {{ selectedService1.Name }} <br />
          <span v-if="numberOfServices > 1">
            <strong> {{ siteText.ui.selectedService }}: </strong>
            {{ selectedService2.Name }} <br />
          </span>
          <strong> {{ siteText.ui.location }}: </strong>
          {{ selectedLocation.Name }},
          <a :href="selectedLocation.MapUrl" target="_blank">{{
            selectedLocation.Address
          }}</a>
          <br />
          <span v-if="selectedDate">
            <strong> {{ siteText.ui.date }}: </strong>
            {{ localeFormattedDate }} <br />
            <strong v-if="selectedTimeSlot"> {{ siteText.ui.time }}: </strong>
            <span v-if="selectedTimeSlot" class="ltr-text-force">
              {{ selectedFormattedAppointmentTime }}
            </span>
          </span>
        </p>
        <p
          v-if="reschedule && selectedTimeSlot"
          :class="isRTLLanguage ? 'rtl' : 'normal'"
        >
          {{ rescheduleMessage }}
        </p>
        <span class="red--text" style="font-size: 14px" v-if="errorMessage">{{
          errorMessage
        }}</span>
      </v-card-text>
    </v-card>
    <p></p>
    <div class="text-left pt-md-4">
      <!-- Desktop Layout -->
      <v-layout row wrap class="hidden-sm-and-down">
        <v-flex md3>
          <v-btn
            class="ma-2 dmv-btn"
            height="45px"
            width="260px"
            @click="back()"
            ><v-icon>mdi-arrow-left</v-icon>
            {{ siteText.ui.selectDateTimeBack }}
          </v-btn>
        </v-flex>
        <v-flex md3>
          <v-btn
            class="ma-2 dmv-btn"
            height="45px"
            width="260px"
            @click="confirmReservation()"
            :disabled="!selectedTimeSlot"
            :aria-disabled="!selectedTimeSlot"
          >
            {{ siteText.ui.selectDateTimeConfirmReservation }}
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <!-- Mobile Layout -->
      <v-layout row wrap class="hidden-md-and-up">
        <v-flex xs12>
          <v-btn
            class="ma-2 dmv-btn"
            height="45px"
            width="260px"
            @click="confirmReservation()"
            :disabled="!selectedTimeSlot"
            :aria-disabled="!selectedTimeSlot"
          >
            {{ siteText.ui.selectDateTimeConfirmReservation }}
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <v-btn
            class="ma-2 dmv-btn"
            height="45px"
            width="260px"
            @click="back()"
            ><v-icon>mdi-arrow-left</v-icon>
            {{ siteText.ui.selectDateTimeBack }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import OpusCalendarDatePicker from "@/components/OpusCalendarDatePicker.vue";
import OpusSelectOnlyDropDown from "@/components/OpusSelectOnlyDropDown.vue";

export default {
  name: "SelectDateTimePage",
  components: {
    OpusCalendarDatePicker,
    OpusSelectOnlyDropDown,
  },
  data: () => ({
    times: [],
    selectedDate: "",
    selectedDate1: "",
    selectedTimeSlot: "",
    time: "",
    picker: "",
    pickerDate: "",
    errorMessage: "",
    newMonth: "",
  }),
  methods: {
    ...mapActions(["getLocationAvailability"]),
    ...mapActions(["setTimeSlot"]),
    ...mapActions(["saveBooking"]),
    nextPage(page) {
      this.$emit("navigateTo", page);
    },
    back() {
      this.$emit("navigateTo", "SelectLocationCountyPage", {
        pageName: "Select Reservation Location",
      });
    },
    async confirmReservation() {
      this.errorMessage = "";

      this.setTimeSlot(this.selectedTimeSlot);
      const bookingResult = await this.saveBooking();

      if (!bookingResult || bookingResult.ErrorCode !== 0) {
        //determine error message
        this.errorMessage = this.determinErrorMessage(bookingResult);
      } else {
        this.$emit("navigateTo", "ConfirmReservationPage", {
          pageName: "Reservation Confirmed",
        });
      }
    },
    datePickerChange() {
      console.log(this.picker);
      this.selectedTimeSlot = null;
      this.time = null;
      this.selectedDate = this.picker;
    },
    onTimeChange() {
      console.log(this.time);
      this.selectedTimeSlot = this.time;
    },
    async onMonthChanged(month) {
      //check for more availability when month changes//
      const dateParts = month.split("-");
      const lastDayOfMonth = this.getLastDayOfMonth(dateParts[0], dateParts[1]);
      if (lastDayOfMonth > this.maxAvailableDate) {
        console.log(
          "New date greater than max available date",
          this.maxAvailableDate,
          lastDayOfMonth
        );
        await this.getLocationAvailability(this.maxAvailableDate);
      }
    },
    allowedDates(ad) {
      return (val) => ad.find((e) => e.AvailabilityDate.includes(val));
    },
    getFirstDayOfMonth(year, month) {
      return new Date(year, month, 1);
    },
    getLastDayOfMonth(year, month) {
      console.log(year, month);
      return new Date(year, month, 0);
    },
    determinErrorMessage(bookingResult) {
      let errorMessage = this.siteText.errors.generalSaveBookingError;
      if (!bookingResult || bookingResult.ErrorCode > 200) {
        errorMessage = this.siteText.errors.generalSaveBookingError;
      } else if (
        bookingResult.ErrorCode === 100 &&
        bookingResult.ExistingBooking
      ) {
        errorMessage = this.buildBookingExistsError(
          bookingResult.ExistingBooking,
          this.siteText.errors.reservationExists
        );
      } else if (
        !bookingResult.ExistingBooking &&
        bookingResult.ErrorCode === 150
      ) {
        errorMessage = bookingResult.ErrorMessage;
      } else if (bookingResult.ErrorCode === 200) {
        errorMessage = this.siteText.errors.slotNoLongerAvailable;
      }
      return errorMessage;
    },
    buildBookingExistsError(booking, msg) {
      let errorMessage = msg
        .replace("FIRST_NAME", booking.FirstName)
        .replace("LAST_NAME", booking.LastName)
        .replace("SITE_NAME", booking.SiteName)
        .replace("BOOKING_DATE", booking.FormattedBookingDateTime);
      const serviceType1 = this.$store.getters.serviceType(
        booking.ServiceTypeId
      );
      errorMessage = errorMessage.replace("SERVICE_1", serviceType1.Name);
      if (booking.ServiceType2 != null) {
        const serviceType2 = this.$store.getters.serviceType(
          booking.ServiceTypeId2
        );
        errorMessage = errorMessage.replace("SERVICE_2", serviceType2.Name);
      } else {
        errorMessage = errorMessage.replace("and SERVICE_2", "");
      }
      return errorMessage;
    },
    onDateChanged(date) {
      this.selectedDate = null;
      this.selectedTimeSlot = null;
      this.time = null;
      this.selectedDate = date.fullDate;
    },
  },
  computed: {
    ...mapGetters(["siteText"]),
    ...mapGetters(["availableLocationDates"]),
    ...mapGetters(["moreDatesAvailable"]),
    ...mapGetters(["selectedLocation"]),
    ...mapGetters("selectedService", [
      "numberOfServices",
      "selectedService1",
      "selectedService2",
    ]),
    ...mapGetters(["language"]),
    ...mapGetters(["maxAvailableDate"]),
    ...mapGetters(["minAvailableDate"]),
    ...mapGetters(["navToSelectDateTimePage"]),
    ...mapGetters(["reschedule"]),
    ...mapGetters(["selectedBooking", "isRTLLanguage"]),
    minDate() {
      let d = null;
      if (!this.minAvailableDate) {
        d = new Date();
        d.setDate(d.getDate());
      } else {
        d = this.minAvailableDate;
        d.setDate(d.getDate());
      }

      const minDate = {
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        date: d.getDate(),
      };
      return minDate;
    },
    maxDate() {
      const d = new Date();
      d.setDate(d.getDate() + 90);
      const maxDate = {
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        date: d.getDate(),
      };
      console.log("max date", maxDate);
      return maxDate;
    },
    availableTimes() {
      let availableTimes = null;
      if (
        this.availableLocationDates &&
        this.availableLocationDates.length > 0 &&
        this.selectedDate
      ) {
        const dateAvailability = this.availableLocationDates.filter((e) => {
          return e.AvailabilityDate.includes(this.selectedDate);
        });
        availableTimes = dateAvailability[0].AvailableTimeSlots;
      }

      let unique = [];
      if (availableTimes) {
        unique = availableTimes.filter((obj, index) => {
          return (
            index ===
            availableTimes.findIndex(
              (o) => obj.FormattedTime === o.FormattedTime
            )
          );
        });
      }
      return unique;
    },
    availableDates() {
      var dates = this.availableLocationDates.map((d) => {
        return {
          month: Number(d.FormattedAvailabilityDateMonth),
          year: Number(d.FormattedAvailabilityDateYear),
          date: Number(d.FormattedAvailabilityDateDay),
        };
      });
      return dates;
    },
    selectedFormatedAppointmentDate() {
      console.log(this.selectedTimeSlot);
      let selectedFormatedAppointmentDate = "";
      if (this.selectedTimeSlot) {
        const bookingDate = new Date(this.selectedTimeSlot.StartDateTime);
        const month = bookingDate.toLocaleString(this.language, {
          month: "long",
        });
        const day = bookingDate.getDate();
        const year = bookingDate.getFullYear();
        selectedFormatedAppointmentDate = `${month} ${day}, ${year}`;
      }
      return selectedFormatedAppointmentDate;
    },
    selectedFormattedAppointmentTime() {
      let selectedFormattedAppointmentTime = "";
      if (this.selectedTimeSlot) {
        selectedFormattedAppointmentTime = this.selectedTimeSlot.FormattedTime;
      }
      return selectedFormattedAppointmentTime;
    },
    rescheduleMessage() {
      return this.siteText.ui.selectDateTimeReservationReschedule
        .replace("OLD_DATE", this.selectedBooking.FormattedBookingDateTime)
        .replace("NEW_DATE", this.selectedTimeSlot.FormattedStartDateTime);
    },
    localeFormattedDate() {
      let d = new Date(this.selectedDate);
      const month = d.toLocaleDateString(this.language, {
        month: "long",
      });
      const date = d.getDate();
      const year = d.getFullYear();
      return `${month} ${date}, ${year}`;
    },
  },
  async mounted() {
    await this.getLocationAvailability();
    this.picker = this.minDate;
    this.selectedTimeSlot = null;
    // common.updateSelectAriaLabel(this.$refs.timeSelect, "Select a time");
  },
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}

.date-color {
  /*color: #00B300;
  font-weight: 900;*/
}

.v-btn--active .date-color {
  /*color: #fff;*/
}
</style>
